import React from 'react';
import { UpdatePlanTaskFormProps } from './UpdateStandardPlanTaskForm';
import BaseStandardTaskForm from './BaseStandardTaskForm';
import UpdateTaskButtons from '../UpdateTaskButtons';
import { usePlanTasksService } from 'nekst-api';

export default function UpdateStandardTaskForm(props: UpdatePlanTaskFormProps) {
  const planTasksService = usePlanTasksService();

  return (
    <BaseStandardTaskForm
      title={props.data.name}
      afterSubmitFunc={props.afterSubmitFunc}
      submitFormFunc={async (request) => {
        return planTasksService.updateTask(props.data.id, request);
      }}
      initialData={props.data}
      validationSchema={planTasksService.getStandardTaskValidationSchema()}
      buttons={<UpdateTaskButtons />}
      planId={props.data.planId}
    />
  );
}
